import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { logoAilosofy } from '../assets/logos';
import { Facebook, Instagram, Twitter, MessageSquare } from 'lucide-react';

export function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const links = {
    company: [
      { label: t('nav.projects'),   href: '#projects' },
      { label: t('nav.howwework'),  href: '#how-we-work' },
      { label: t('nav.founder'),    href: '#founder' },
      { label: t('nav.contact'),    href: '#contact' },
    ],
    services: [
      { label: t('nav.service.whatsapp'),  href: '#whatsapp' },
      { label: t('nav.service.business'),  href: '#business-automation' },
      { label: t('nav.service.chatbots'),  href: '#chatbots' },
      { label: t('nav.service.data'),      href: '#data-analysis' },
      { label: t('nav.service.logistics'), href: '#logistics' },
      { label: t('nav.service.marketing'), href: '#marketing' },
    ],
    products: [
      { label: 'BookerClub',        href: 'https://bookerpromanager.com' },
      { label: 'ShiftMaster Pro',   href: 'https://shiftmasterpro1.netlify.app' },
      { label: 'Simplificando',     href: 'https://simplificando.app' },
      { label: 'CasaBlanca Polo',   href: 'https://casablancapolo.com' },
      { label: 'GRIM Circle',       href: 'https://grimcircles.com' },
      { label: 'MJF Advisors',      href: 'https://www.mjfurtado.com' },
    ],
  };

  const social = [
    { Icon: Facebook,     href: 'https://www.facebook.com/profile.php?id=61572070054049&sk=about', label: 'Facebook' },
    { Icon: Instagram,    href: 'https://www.instagram.com/jerofur/', label: 'Instagram' },
    { Icon: Twitter,      href: 'https://x.com/jerryFurt', label: 'X (Twitter)' },
    { Icon: MessageSquare,href: 'https://wa.me/5491168032436', label: 'WhatsApp' },
  ];

  return (
    <footer className="bg-surface-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        {/* Top grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl overflow-hidden flex-shrink-0">
                <img src={logoAilosofy} alt="AiLosofy" className="w-full h-full object-cover" />
              </div>
              <span className="text-lg font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                AiLosofy
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-3">
              {social.map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg bg-white/5 hover:bg-primary flex items-center justify-center transition-colors duration-200">
                  <Icon className="w-4 h-4 text-slate-400 hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">{t('footer.col.company')}</h4>
            <ul className="space-y-2">
              {links.company.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-slate-400 hover:text-white text-sm transition-colors duration-200">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">{t('footer.col.services')}</h4>
            <ul className="space-y-2">
              {links.services.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-slate-400 hover:text-white text-sm transition-colors duration-200">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">{t('footer.col.products')}</h4>
            <ul className="space-y-2">
              {links.products.map((l) => (
                <li key={l.label}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer"
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {year} AiLosofy. {t('footer.rights')}
          </p>
          <p className="text-slate-500 text-sm">
            {t('footer.made')} · Buenos Aires, Argentina 🇦🇷
          </p>
        </div>

      </div>
    </footer>
  );
}